// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3HN2K","appear":"styles_appear__2V4Wv","button":"styles_button__135XU","border":"styles_border__2aEs4"};